import { render, staticRenderFns } from "./emoji-picker-dialog.vue?vue&type=template&id=2162327d&scoped=true"
import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./style/index.scss?vue&type=style&index=0&id=2162327d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162327d",
  null
  
)

export default component.exports